import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=aa908624&scoped=true&"
import script from "./AppSetting.vue?vue&type=script&lang=js&"
export * from "./AppSetting.vue?vue&type=script&lang=js&"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=aa908624&scoped=true&lang=css&"
import style1 from "./AppSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa908624",
  null
  
)

export default component.exports